import React from 'react';
import ResendIcon from 'src/common/utils/TableColumnIcons/ResendIcon';

export const ResendColumn = (value, row, rowIndex, { onResend }) => {
	return <ResendIcon onClick={() => onResend(value)} tooltip="Reenviar notificación" />;
};
